import { faChevronDown, faChevronUp, faMultiply } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import Button from "../../button/Button";
import Dropdown from "../../dropdown/Dropdown";
import { IDropdownItem } from "../../dropdown/dropdownUtils";
import Tag from "../../tag/Tag";
import { findAllFilters, IFilter } from "../utils/filteringUtils";

import "./FilterDropdown.scss";

interface IProps {
    label: string;
    filters: IFilter[];
    onFiltersChange: (filters: IFilter[]) => void;
    maxHeight?: number;
}

export default function FilterDropdown(props: IProps) {
    const { t } = useTranslation();

    const [isOpen, setIsOpen] = useState(false);

    const { value, additionalSelected } = findAllFilters(props.filters);

    const items: IDropdownItem[] = props.filters.map((filter: IFilter, index) => ({
        id: filter.id,
        title: filter.name,
        options: "checkbox",
        value: filter.value ? "selected" : "unselected",
        doNotCloseOnClick: true,
        devider: index + 1 >= props.filters.length,
    }));

    items.push({
        id: "clear-all",
        title: "Filters.clear-all",
        icon: <FontAwesomeIcon icon={faMultiply} />,
        doNotCloseOnClick: false,
    });

    return (
        <Dropdown
            items={items}
            onOpenChange={(open) => {
                setIsOpen(open);
            }}
            maxHeight={props.maxHeight}
            onChange={(item) => {
                if (item.id === "clear-all") {
                    props.onFiltersChange(props.filters.map((filter) => ({ ...filter, value: false })));
                    return;
                }

                const updatedFilters = props.filters.map((filter) => {
                    if (filter.id === item.id) {
                        return { ...filter, value: !filter.value };
                    }
                    return filter;
                });
                props.onFiltersChange(updatedFilters);
            }}
            trigger={
                <Button variant="secondary" className="userful-filter-dropdown">
                    <h1>{t("Filters." + props.label)}</h1>
                    <div className="userful-filter-dropdown-selected">
                        <p>{t(value)}</p>
                        {additionalSelected > 0 && <Tag variant="dark-grey">{additionalSelected}</Tag>}
                    </div>
                    <div className="userful-dropdown-icon-wrapper">
                        <FontAwesomeIcon icon={isOpen ? faChevronUp : faChevronDown} />
                    </div>
                </Button>
            }
        />
    );
}
